module.exports = __webpack_public_path__ + "static/img/NAS.e867e9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/NAS.svg
// module id = ia9F
// module chunks = 2